module.exports = __webpack_public_path__ + "img/img-cp.38170a38.png";